import { render, staticRenderFns } from "./fapiaoList.vue?vue&type=template&id=4985ecdd&scoped=true"
import script from "./fapiaoList.vue?vue&type=script&lang=js"
export * from "./fapiaoList.vue?vue&type=script&lang=js"
import style0 from "./fapiaoList.vue?vue&type=style&index=0&id=4985ecdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985ecdd",
  null
  
)

export default component.exports